'use client'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html lang="ja">
      <body className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-5xl mb-4">🚨</p>
          <h1 className="text-xl font-bold text-[#202833] mb-2">システムエラーが発生しました</h1>
          <p className="text-sm text-gray-400 mb-8">
            {error.message ?? '予期しないエラーが発生しました。'}
          </p>
          <button
            onClick={reset}
            className="px-6 py-2.5 bg-[#202833] text-white text-sm font-medium rounded-xl hover:bg-[#2d3a47] transition-colors"
          >
            再試行する
          </button>
        </div>
      </body>
    </html>
  )
}
